/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { InviteUsersAndTeams, List, MemberRole, MemberRoleOrGuest, UserContentPermission } from "./data-contracts";

/**
 * No description
 * @tags collection-users
 * @name InviteToCollection
 * @summary Invite to a collection
 * @request POST:/collections/{collectionId}/permissions
 * @secure
 */

// @ts-ignore
export const inviteToCollection: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
  };
  RequestQuery: {};
  RequestBody: InviteUsersAndTeams;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions",
  method: "post",
  streaming: false,
  tags: ["collection-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-users
 * @name ListUserPermissionsInCollection
 * @summary List collection user permissions
 * @request GET:/collections/{collectionId}/permissions/users
 * @secure
 */

// @ts-ignore
export const listUserPermissionsInCollection: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/collections/{collectionId}/permissions/users",
  method: "get",
  streaming: false,
  tags: ["collection-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-users
 * @name UpdateUserPermissionInCollection
 * @summary Update a collection user permission
 * @request PATCH:/collections/{collectionId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const updateUserPermissionInCollection: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions/users/{userId}",
  method: "patch",
  streaming: false,
  tags: ["collection-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-users
 * @name RemoveUserFromCollection
 * @summary Remove a user from a collection
 * @request DELETE:/collections/{collectionId}/permissions/users/{userId}
 * @secure
 */

// @ts-ignore
export const removeUserFromCollection: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/collections/{collectionId}/permissions/users/{userId}",
  method: "delete",
  streaming: false,
  tags: ["collection-users"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-users
 * @name ListPermissionsAggregateInCollection
 * @summary List all collections users permissions
 * @request GET:/collections/{collectionId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInCollection: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If defined, only members with this role will be returned. */
    role?: MemberRole;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["collection-users"],
  criticalityLevel: "low",
  deprecated: false,
};
